import * as actionTypes from '../../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_POP_SCHEDULE_VALIDATION_ERROR:
      return action.payload;
    case actionTypes.GET_POP_SCHEDULE_VALIDATION_SUCCESS:
      return action.payload.valid;
    default:
      return state;
  }
}
